import './Error.scss';

export default function Error() {
    return (
        <div className="error container">
            <h2>
                404
            </h2>
        </div>
    )
}